export default "__VITE_PUBLIC_ASSET__4fa5fb10__"